const ok = () => {
  document.getElementById('dialogbox').style.display = "none";
  document.getElementById('dialogoverlay').style.display = "none";
}

export const cobraSubmittedAlert = (caseId, navigate) => {
  let dialogContainer = document.getElementById('dialogContainer');

  if (!dialogContainer) {
    dialogContainer = document.createElement('div');
    dialogContainer.id = 'dialogContainer';
    document.body.appendChild(dialogContainer);
  }

  dialogContainer.innerHTML = `
    <div id="dialogoverlay"></div>
    <div id="dialogbox" class="slit-in-vertical">
      <div>
        <div id="dialogboxhead"></div>
        <div id="dialogboxbody"></div>
        <div id="dialogboxfoot"></div>
      </div>
    </div>
  `;

  const dialogoverlay = document.getElementById('dialogoverlay');
  const dialogbox = document.getElementById('dialogbox');

  const winH = window.innerHeight;
  dialogoverlay.style.height = winH + "px";

  dialogbox.style.top = "100px";
  dialogoverlay.style.display = "block";
  dialogbox.style.display = "block";

  const dialogboxhead = document.getElementById('dialogboxhead');
  document.getElementById('dialogboxhead').style.display = 'block';
  document.getElementById('dialogboxhead').style.color = '#679c5b';
  document.getElementById('dialogboxhead').innerHTML = '<i class="fa fa-check-circle" aria-hidden="true"></i> Success';

  document.getElementById('dialogboxbody').innerHTML = "Your submission is complete. It is now being reviewed and will be processed within the next 10 business days.";

  const okButton = document.createElement('button');
  okButton.className = "pure-material-button-contained-yes active me-2";
  okButton.textContent = "Ok";
  okButton.onclick = () => {
    dialogContainer.remove();
    navigate(`/CobraSummary/${caseId}`);  
  };

  const dialogboxfoot = document.getElementById('dialogboxfoot');
  dialogboxfoot.innerHTML = '';
  dialogboxfoot.appendChild(okButton);
};

export const ebSubmittedAlert = (caseId, navigate) => {
  let dialogContainer = document.getElementById('dialogContainer');

  if (!dialogContainer) {
    dialogContainer = document.createElement('div');
    dialogContainer.id = 'dialogContainer';
    document.body.appendChild(dialogContainer);
  }

  dialogContainer.innerHTML = `
    <div id="dialogoverlay"></div>
    <div id="dialogbox" class="slit-in-vertical">
      <div>
        <div id="dialogboxhead"></div>
        <div id="dialogboxbody"></div>
        <div id="dialogboxfoot"></div>
      </div>
    </div>
  `;

  const dialogoverlay = document.getElementById('dialogoverlay');
  const dialogbox = document.getElementById('dialogbox');

  const winH = window.innerHeight;
  dialogoverlay.style.height = winH + "px";

  dialogbox.style.top = "100px";
  dialogoverlay.style.display = "block";
  dialogbox.style.display = "block";

  const dialogboxhead = document.getElementById('dialogboxhead');
  document.getElementById('dialogboxhead').style.display = 'block';
  document.getElementById('dialogboxhead').style.color = '#679c5b';
  document.getElementById('dialogboxhead').innerHTML = '<i class="fa fa-check-circle" aria-hidden="true"></i> Success';

  document.getElementById('dialogboxbody').innerHTML = "Your submission is complete. It is now being reviewed and will be processed within the next 10 business days.";

  const okButton = document.createElement('button');
  okButton.className = "pure-material-button-contained-yes active me-2";
  okButton.textContent = "Ok";
  okButton.onclick = () => {
    dialogContainer.remove();
    navigate(`/EmployeeBenefitsSummary/${caseId}`);  
  };

  const dialogboxfoot = document.getElementById('dialogboxfoot');
  dialogboxfoot.innerHTML = '';
  dialogboxfoot.appendChild(okButton);
};



export const uploadedFileAlert = (resetFormCallback) => {
  let dialogContainer = document.getElementById('dialogContainer');
  
  if (!dialogContainer) {
    dialogContainer = document.createElement('div');
    dialogContainer.id = 'dialogContainer';
    document.body.appendChild(dialogContainer);
  }

  dialogContainer.innerHTML = `
    <div id="dialogoverlay"></div>
    <div id="dialogbox" class="slit-in-vertical">
      <div>
        <div id="dialogboxhead"></div>
        <div id="dialogboxbody"></div>
        <div id="dialogboxfoot"></div>
      </div>
    </div>
  `;

  const dialogoverlay = document.getElementById('dialogoverlay');
  const dialogbox = document.getElementById('dialogbox');

  const winH = window.innerHeight;
  dialogoverlay.style.height = winH + "px";

  dialogbox.style.top = "100px";
  
  dialogoverlay.style.display = "block";
  dialogbox.style.display = "block";

  const dialogboxhead = document.getElementById('dialogboxhead');
  document.getElementById('dialogboxhead').style.display = 'block';
  document.getElementById('dialogboxhead').style.color = '#679c5b';
  document.getElementById('dialogboxhead').innerHTML = '<i class="fa fa-check-circle" aria-hidden="true"></i> Success';

  document.getElementById('dialogboxbody').innerHTML = "File uploaded successfully.";

  const okButton = document.createElement('button');
  okButton.className = "pure-material-button-contained-yes active me-2";
  okButton.textContent = "Ok";
  okButton.onclick = () => {
    dialogContainer.remove();
    if (resetFormCallback) {
      resetFormCallback();  
    }
  };

  const dialogboxfoot = document.getElementById('dialogboxfoot');
  dialogboxfoot.innerHTML = '';
  dialogboxfoot.appendChild(okButton);
};

export const deleteFileAlert = (fileUrl, fileId, handleDeleteFile) => {
  let dialogContainer = document.getElementById('dialogContainer');
  
  if (!dialogContainer) {
    dialogContainer = document.createElement('div');
    dialogContainer.id = 'dialogContainer';
    document.body.appendChild(dialogContainer);
  }

  dialogContainer.innerHTML = `
    <div id="dialogoverlay"></div>
    <div id="dialogbox" class="slit-in-vertical">
      <div>
        <div id="dialogboxhead"></div>
        <div id="dialogboxbody"></div>
        <div id="dialogboxfoot"></div>
      </div>
    </div>
  `;

  const dialogoverlay = document.getElementById('dialogoverlay');
  const dialogbox = document.getElementById('dialogbox');

  const winH = window.innerHeight;
  dialogoverlay.style.height = winH + "px";

  dialogbox.style.top = "100px";
  
  dialogoverlay.style.display = "block";
  dialogbox.style.display = "block";

  const dialogboxhead = document.getElementById('dialogboxhead');
  document.getElementById('dialogboxhead').style.display = 'block';
  document.getElementById('dialogboxhead').style.color = '#ff4d4d'; // Red for warning
  document.getElementById('dialogboxhead').innerHTML = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i> Confirm Delete';

  document.getElementById('dialogboxbody').innerHTML = "Are you sure you want to delete this file?";

  const okButton = document.createElement('button');
  okButton.className = "pure-material-button-contained-yes active me-2";
  okButton.textContent = "Ok";
  okButton.onclick = () => {
    dialogContainer.remove();
    handleDeleteFile(fileUrl, fileId); // Call the delete function
  };

  const cancelButton = document.createElement('button');
  cancelButton.className = "pure-material-button-contained active";
  cancelButton.textContent = "Cancel";
  cancelButton.onclick = () => {
    dialogContainer.remove(); // Close the dialog without deleting
  };

  const dialogboxfoot = document.getElementById('dialogboxfoot');
  dialogboxfoot.innerHTML = '';
  dialogboxfoot.appendChild(okButton);
  dialogboxfoot.appendChild(cancelButton);
};

export const saveAlert = () => {
  let dialogContainer = document.getElementById('dialogContainer');
  
  if (!dialogContainer) {
    dialogContainer = document.createElement('div');
    dialogContainer.id = 'dialogContainer';
    document.body.appendChild(dialogContainer);
  }

  dialogContainer.innerHTML = `
    <div id="dialogoverlay"></div>
    <div id="dialogbox" class="slit-in-vertical">
      <div>
        <div id="dialogboxhead"></div>
        <div id="dialogboxbody"></div>
        <div id="dialogboxfoot"></div>
      </div>
    </div>
  `;

  const dialogoverlay = document.getElementById('dialogoverlay');
  const dialogbox = document.getElementById('dialogbox');

  const winH = window.innerHeight;
  dialogoverlay.style.height = winH + "px";

  dialogbox.style.top = "100px";
  
  dialogoverlay.style.display = "block";
  dialogbox.style.display = "block";

  const dialogboxhead = document.getElementById('dialogboxhead');
  document.getElementById('dialogboxhead').style.display = 'block';
  document.getElementById('dialogboxhead').style.color = '#679c5b';
  document.getElementById('dialogboxhead').innerHTML = '<i class="fa fa-check-circle" aria-hidden="true"></i> Success';

  document.getElementById('dialogboxbody').innerHTML = "Data saved successfully.";

  const okButton = document.createElement('button');
  okButton.className = "pure-material-button-contained-yes active me-2";
  okButton.textContent = "Ok";
  okButton.onclick = () => {
    dialogContainer.remove();
    //window.location.reload();
  };

  const dialogboxfoot = document.getElementById('dialogboxfoot');
  dialogboxfoot.innerHTML = '';
  dialogboxfoot.appendChild(okButton);
};



export const confirmation = (message, title, yesCallback, noCallback) => {
  let dialogContainer = document.getElementById('dialogContainer');
  
  if (!dialogContainer) {
    dialogContainer = document.createElement('div');
    dialogContainer.id = 'dialogContainer';
    document.body.appendChild(dialogContainer);
  }

  dialogContainer.innerHTML = `
    <div id="dialogoverlay"></div>
    <div id="dialogbox" class="slit-in-vertical">
      <div>
        <div id="dialogboxhead"></div>
        <div id="dialogboxbody"></div>
        <div id="dialogboxfoot"></div>
      </div>
    </div>
  `;

  const dialogoverlay = document.getElementById('dialogoverlay');
  const dialogbox = document.getElementById('dialogbox');

  const winH = window.innerHeight;
  dialogoverlay.style.height = winH + "px";

  dialogbox.style.top = "100px";
  
  dialogoverlay.style.display = "block";
  dialogbox.style.display = "block";

  const dialogboxhead = document.getElementById('dialogboxhead');
  if (title) {
    dialogboxhead.style.display = 'block';
    dialogboxhead.innerHTML = `<i class="fa fa-exclamation-circle" aria-hidden="true"></i> ${title}`;
  } else {
    dialogboxhead.style.display = 'none';
  }

  document.getElementById('dialogboxbody').innerHTML = message;

  const yesButton = document.createElement('button');
  yesButton.className = "pure-material-button-contained-yes active me-2";
  yesButton.textContent = "Ok";
  yesButton.onclick = () => {
    dialogContainer.remove();
    if (yesCallback) yesCallback();
  };

  const noButton = document.createElement('button');
  noButton.className = "pure-material-button-contained active";
  noButton.textContent = "Cancel";
  noButton.onclick = () => {
    dialogContainer.remove();
    if (noCallback) noCallback();
  };

  const dialogboxfoot = document.getElementById('dialogboxfoot');
  dialogboxfoot.innerHTML = '';
  dialogboxfoot.appendChild(yesButton);
  dialogboxfoot.appendChild(noButton);
};


export const alertconfirmation = (message, title, yesCallback, noCallback) => {
  let dialogContainer = document.getElementById('dialogContainer');
  
  if (!dialogContainer) {
    dialogContainer = document.createElement('div');
    dialogContainer.id = 'dialogContainer';
    document.body.appendChild(dialogContainer);
  }

  dialogContainer.innerHTML = `
    <div id="dialogoverlay"></div>
    <div id="dialogbox" class="slit-in-vertical">
      <div>
        <div id="dialogboxhead"></div>
        <div id="dialogboxbody"></div>
        <div id="dialogboxfoot"></div>
      </div>
    </div>
  `;

  const dialogoverlay = document.getElementById('dialogoverlay');
  const dialogbox = document.getElementById('dialogbox');

  const winH = window.innerHeight;
  dialogoverlay.style.height = winH + "px";

  dialogbox.style.top = "100px";
  
  dialogoverlay.style.display = "block";
  dialogbox.style.display = "block";

  const dialogboxhead = document.getElementById('dialogboxhead');
  if (title) {
    dialogboxhead.style.display = 'block';
    dialogboxhead.innerHTML = `<i class="fa fa-exclamation-circle" aria-hidden="true"></i> ${title}`;
  } else {
    dialogboxhead.style.display = 'none';
  }

  document.getElementById('dialogboxbody').innerHTML = message;

  const yesButton = document.createElement('button');
  yesButton.className = "pure-material-button-contained-yes active me-2";
  yesButton.textContent = "Yes";
  yesButton.onclick = () => {
    dialogContainer.remove();
    if (yesCallback) yesCallback();
  };

  const noButton = document.createElement('button');
  noButton.className = "pure-material-button-contained active";
  noButton.textContent = "No";
  noButton.onclick = () => {
    dialogContainer.remove();
    if (noCallback) noCallback();
  };

  const dialogboxfoot = document.getElementById('dialogboxfoot');
  dialogboxfoot.innerHTML = '';
  dialogboxfoot.appendChild(yesButton);
  dialogboxfoot.appendChild(noButton);
};




export const planRulebox = () => {
  let dialogContainer = document.getElementById('dialogContainer');

  if (!dialogContainer) {
    dialogContainer = document.createElement('div');
    dialogContainer.id = 'dialogContainer';
    document.body.appendChild(dialogContainer);
  }

  dialogContainer.innerHTML = `
    <div id="dialogoverlay"></div>
    <div id="dialogbox" class="slit-in-vertical">
      <div>
        <div id="dialogboxhead"></div>
        <div id="dialogboxbody"></div>
        <div id="dialogboxfoot"></div>
      </div>
    </div>
  `;

  const dialogoverlay = document.getElementById('dialogoverlay');
  const dialogbox = document.getElementById('dialogbox');

  const winH = window.innerHeight;
  dialogoverlay.style.height = winH + "px";

  dialogbox.style.top = "100px";
  dialogoverlay.style.display = "block";
  dialogbox.style.display = "block";

  const dialogboxhead = document.getElementById('dialogboxhead');
  dialogboxhead.style.display = 'none';

  document.getElementById('dialogboxbody').innerHTML = `
    <h3>Loss of Coverage Determination</h3>
<p ></p>
    <p ><strong>Date Of Qualifying Event</strong></p>
    <p>Loss of Coverage is the day of the Qualifying Event. The First Day of Coverage is the day after.</p>
    <p><strong>End Of Month</strong></p>
    <p>Loss of Coverage is the last day of the month of the Qualifying Event. The First Day of Coverage is the first of the next month.</p>
    <p><strong>Roll Roll</strong></p>
    <p>If the Qualifying Event is on the 1st to the 15th day of the month, the Loss of Coverage is on the 15th day of the month, and the First Day of Coverage is the 16th.</p>
    <p>If the Qualifying Event is on the 16th to the 31st day of the month, the Loss of Coverage is on the last day of the month, and the First Day of Coverage is the 1st of the next month following the Qualifying Event.</p>
    <p><strong>Wash Roll</strong></p>
    <p>If the Qualifying Event is on the 1st to the 15th day of the month, the Loss of Coverage is on the last day of the previous month, and the First Day of Coverage is the 1st of the month.</p>
    <p>If the Qualifying Event is on the 16th to the 31st day of the month, the Loss of Coverage is on the last day of the month, and the First Day of Coverage is the 1st of the next month following the Qualifying Event.</p>
  `;

  const okButton = document.createElement('button');
  okButton.className = "pure-material-button-contained-yes active me-2";
  okButton.textContent = "Close";
  okButton.onclick = () => {
    dialogContainer.remove();
    
  };

  const dialogboxfoot = document.getElementById('dialogboxfoot');
  dialogboxfoot.innerHTML = '';
  dialogboxfoot.appendChild(okButton);
};


export const formSubmissionAlert = () => {
  let dialogContainer = document.getElementById('dialogContainer');
  
  if (!dialogContainer) {
    dialogContainer = document.createElement('div');
    dialogContainer.id = 'dialogContainer';
    document.body.appendChild(dialogContainer);
  }

  dialogContainer.innerHTML = `
    <div id="dialogoverlay"></div>
    <div id="dialogbox" class="slit-in-vertical">
      <div>
        <div id="dialogboxhead"></div>
        <div id="dialogboxbody"></div>
        <div id="dialogboxfoot"></div>
      </div>
    </div>
  `;

  const dialogoverlay = document.getElementById('dialogoverlay');
  const dialogbox = document.getElementById('dialogbox');

  const winH = window.innerHeight;
  dialogoverlay.style.height = winH + "px";

  dialogbox.style.top = "100px";
  
  dialogoverlay.style.display = "block";
  dialogbox.style.display = "block";

  const dialogboxhead = document.getElementById('dialogboxhead');
  document.getElementById('dialogboxhead').style.display = 'block';
  document.getElementById('dialogboxhead').style.color = '#ff4d4d'; // Red for warning
  document.getElementById('dialogboxhead').innerHTML = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i> Warning';

  document.getElementById('dialogboxbody').innerHTML = "You cannot access the summary page until the case is submitted.";

  const okButton = document.createElement('button');
  okButton.className = "pure-material-button-contained-yes active me-2";
  okButton.textContent = "Ok";
  okButton.onclick = () => {
    dialogContainer.remove();
   
  };



  const dialogboxfoot = document.getElementById('dialogboxfoot');
  dialogboxfoot.innerHTML = '';
  dialogboxfoot.appendChild(okButton);
};




// export const terminationAlert = (message, title, yesCallback, noCallback) => {
//   var dialogContainer = document.getElementById('dialogContainer');
//   if (!dialogContainer) {
//       dialogContainer = document.createElement('div');
//       dialogContainer.id = 'dialogContainer';
//       document.body.appendChild(dialogContainer);
//   }

//   dialogContainer.innerHTML = '<div id="dialogoverlay"></div><div id="dialogbox" class="slit-in-vertical"><div><div id="dialogboxhead"></div><div id="dialogboxbody"></div><div id="dialogboxfoot"></div></div></div>';

//   var dialogoverlay = document.getElementById('dialogoverlay');
//   var dialogbox = document.getElementById('dialogbox');

//   var winH = window.innerHeight;
//   dialogoverlay.style.height = winH + "px";

//   dialogbox.style.top = "100px";

//   dialogoverlay.style.display = "block";
//   dialogbox.style.display = "block";

//   var dialogboxhead = document.getElementById('dialogboxhead');
//   if (typeof title === 'undefined') {
//       dialogboxhead.style.display = 'none';
//   } else {
//       dialogboxhead.style.display = 'block';
//       dialogboxhead.innerHTML = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i> ' + title;
//   }

//   document.getElementById('dialogboxbody').innerHTML = message;

//   var yesButton = document.createElement('button');
//   yesButton.className = "pure-material-button-contained-yes active me-2";
//   yesButton.textContent = "Save";
//   yesButton.onclick = (() => dialogContainer.remove());

//   var noButton = document.createElement('button');
//   noButton.className = "pure-material-button-contained active";
//   noButton.textContent = "Cancel";
//   noButton.onclick = () => {
//       alertPlanMappingWarning(
//           'This plan mapping is required to complete your COBRA renewal. Canceling will leave your COBRA renewal incomplete. Do you still wish to Cancel?',
//           'Warning',
//           message,
//           () => {
//               terminationAlert(
//                 message,
//                 title,
//                   () => {},
//                   () => {}
//               );
//           },
//           () => {}
//       );
//   };

//   document.getElementById('dialogboxfoot').innerHTML = '';
//   document.getElementById('dialogboxfoot').appendChild(yesButton);
//   document.getElementById('dialogboxfoot').appendChild(noButton);
// };


// export const alertPlanMappingWarning = (message, title, terminationAlertContent, yesCallback, noCallback) => {
//   var dialogContainer = document.getElementById('dialogContainer');
//   if (!dialogContainer) {
//       dialogContainer = document.createElement('div');
//       dialogContainer.id = 'dialogContainer';
//       document.body.appendChild(dialogContainer);
//   }

//   dialogContainer.innerHTML = '<div id="dialogoverlay"></div><div id="dialogbox" class="slit-in-vertical"><div><div id="dialogboxhead"></div><div id="dialogboxbody"></div><div id="dialogboxfoot"></div></div></div>';

//   var dialogoverlay = document.getElementById('dialogoverlay');
//   var dialogbox = document.getElementById('dialogbox');

//   var winH = window.innerHeight;
//   dialogoverlay.style.height = winH + "px";

//   dialogbox.style.top = "100px";

//   dialogoverlay.style.display = "block";
//   dialogbox.style.display = "block";

//   var dialogboxhead = document.getElementById('dialogboxhead');
//   if (typeof title === 'undefined') {
//       dialogboxhead.style.display = 'none';
//   } else {
//       dialogboxhead.style.display = 'block';
//       dialogboxhead.style.color = '#FF6347';
//       dialogboxhead.innerHTML = '<i class="fa fa-exclamation-circle" aria-hidden="true"></i> ' + title;
//   }

//   document.getElementById('dialogboxbody').innerHTML = message;

//   var yesButton = document.createElement('button');
//   yesButton.className = "pure-material-button-contained-yes active me-2";
//   yesButton.textContent = "Yes";
//   yesButton.onclick = (() => dialogContainer.remove());

//   var noButton = document.createElement('button');
//   noButton.className = "pure-material-button-contained active";
//   noButton.textContent = "No";
//   noButton.onclick = () => {
//       terminationAlert(
//           terminationAlertContent,
//           "Plan Mapping",
//           () => {},
//           () => {}
//       );
//   };

//   document.getElementById('dialogboxfoot').innerHTML = '';
//   document.getElementById('dialogboxfoot').appendChild(yesButton);
//   document.getElementById('dialogboxfoot').appendChild(noButton);
// };

